import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
// Register Chart + date adapter once in the main bundle so lazy routes share the same
// date-fns graph (avoids ChunkLoadError for async date-fns chunks after HMR or deploy).
import 'chart.js/auto'
import 'chartjs-adapter-date-fns'

// Developer easter egg — a small thank-you for the curious
console.log(
  '%c 🌱 PecSmart Support Platform ',
  'background: #1a1a16; color: #78b843; font-family: monospace; font-size: 14px; font-weight: bold; padding: 8px 16px; border-radius: 4px;'
);

// Suppress harmless ResizeObserver errors from triggering the webpack-dev-server overlay
const resizeObserverErrRe = /^[a-zA-Z: ]*ResizeObserver loop completed with undelivered notifications/;
window.addEventListener('error', (e) => {
  if (resizeObserverErrRe.test(e.message)) {
    e.stopImmediatePropagation();
    const overlay = document.getElementById('webpack-dev-server-client-overlay');
    if (overlay) {
      overlay.style.display = 'none';
    }
  }
});

createApp(App).use(router).use(createPinia()).mount('#app')
